import { STATIC_ASSETS_PLACEHOLDER } from "../staticAssetsPlaceholder.js";
const greetingLinesAsScenesSceneBackground = {
    variant: "plain-color",
    color: "transparent",
};
const sceneTransition = {
    variant: "zoom-in",
    timing: {
        variant: "linear",
        easing: "easeOut",
        durationSeconds: 1,
    },
};
const burstStarGeneral = {
    url: {
        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/burst_star_01.png`,
        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/optimized/burst_star_01.webp`,
    },
    width: 1192,
    height: 1190,
    direction: "random",
    animate: {
        variant: "rotate",
    },
};
export const bigCongrats = {
    version: 1,
    themeId: "big-congrats",
    name: "Big Congrats",
    endFadeDuration: 1,
    thumbnailFrame: 100,
    thumbnailUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/theme-stills/big-congrats.webp`,
    background: [
        {
            variant: "big-congrats",
            colorDurationSeconds: 8,
            borderImage: {
                full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/balloon_border_1.webp`,
                preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/optimized/balloon_border_1.webp`,
            },
            colors: [
                // red
                "#bc4b4d",
                // orange
                "#d89101",
                // teal
                "#5ba775",
                // blue
                "#42a8bb",
                // purple
                "#7959a4",
            ],
            flowImages: [
                {
                    full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/balloon_dots_a.webp`,
                    preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/optimized/balloon_dots_a.webp`,
                },
                {
                    full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/balloon_dots_b.webp`,
                    preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/optimized/balloon_dots_b.webp`,
                },
            ],
        },
    ],
    scenes: [
        {
            type: "bigCongratsIntro",
            durationSeconds: 5,
            faceCollage: {
                variant: "top-bottom-static",
                borderShape: "circle",
                borderWidth: 0,
                entrance: {
                    variant: "random-pop-in",
                    transitionDurationInFrames: 160,
                    topStyle: {
                        paddingTop: "80px",
                        paddingLeft: "80px",
                        paddingRight: "80px",
                    },
                    bottomStyle: {
                        paddingBottom: "80px",
                        paddingLeft: "80px",
                        paddingRight: "80px",
                    },
                },
                startAtSeconds: 0.5,
            },
            bigCongratsText: {
                invert: true,
                maxScale: 0.8,
                url: {
                    full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/text_congrats.png`,
                    preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/optimized/text_congrats.webp`,
                },
            },
            burstImages: [
                // SLASHES
                {
                    url: {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/burst_slash_00.png`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/optimized/burst_slash_00.webp`,
                    },
                    width: 378,
                    height: 1329,
                    location: { edge: "bottom", zone: 6 },
                    animate: {
                        variant: "tilt",
                        direction: "right",
                    },
                },
                {
                    url: {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/burst_slash_01.png`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/optimized/burst_slash_01.webp`,
                    },
                    width: 1052,
                    height: 2172,
                    location: { edge: "bottom", zone: 2 },
                    animate: {
                        variant: "tilt",
                        direction: "left",
                    },
                },
                {
                    url: {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/burst_slash_04.png`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/optimized/burst_slash_04.webp`,
                    },
                    width: 1315,
                    height: 1807,
                    location: { edge: "bottom", zone: 8 },
                    animate: {
                        variant: "tilt",
                        direction: "right",
                    },
                },
                {
                    url: {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/burst_slash_02.png`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/optimized/burst_slash_02.webp`,
                    },
                    width: 1080,
                    height: 585,
                    location: { edge: "right", zone: 8 },
                    animate: {
                        variant: "tilt",
                        direction: "right",
                    },
                },
                {
                    url: {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/burst_slash_06.png`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/optimized/burst_slash_06.webp`,
                    },
                    width: 1172,
                    height: 752,
                    location: { edge: "right", zone: 2 },
                    animate: {
                        variant: "tilt",
                        direction: "right",
                    },
                },
                {
                    url: {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/burst_slash_03.png`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/optimized/burst_slash_03.webp`,
                    },
                    width: 1085,
                    height: 876,
                    location: { edge: "left", zone: 8 },
                    animate: {
                        variant: "tilt",
                        direction: "left",
                    },
                },
                {
                    url: {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/burst_slash_08.png`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/optimized/burst_slash_08.webp`,
                    },
                    width: 1618,
                    height: 861,
                    location: { edge: "left", zone: 2 },
                    animate: {
                        variant: "tilt",
                        direction: "left",
                    },
                },
                {
                    url: {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/burst_slash_05.webp`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/optimized/burst_slash_05.webp`,
                    },
                    width: 427,
                    height: 1518,
                    location: { edge: "top", zone: 7 },
                    animate: {
                        variant: "tilt",
                        direction: "right",
                    },
                },
                {
                    url: {
                        full: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/burst_slash_07.png`,
                        preview: `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/big-congrats/optimized/burst_slash_07.webp`,
                    },
                    width: 590,
                    height: 1255,
                    location: { edge: "top", zone: 3 },
                    animate: {
                        variant: "tilt",
                        direction: "left",
                    },
                },
                // STARS
                {
                    ...burstStarGeneral,
                    delaySeconds: 0.08,
                    location: { edge: "top", zone: 1 },
                    scale: 1.8,
                },
                {
                    ...burstStarGeneral,
                    delaySeconds: 0.05,
                    location: { edge: "top", zone: 9 },
                    scale: 2.6,
                },
                {
                    ...burstStarGeneral,
                    delaySeconds: 0.1,
                    location: { edge: "top", zone: 5 },
                    scale: 2.9,
                },
                {
                    ...burstStarGeneral,
                    delaySeconds: 0.07,
                    location: { edge: "right", zone: 2 },
                    scale: 2.7,
                },
                {
                    ...burstStarGeneral,
                    delaySeconds: 0.06,
                    location: { edge: "right", zone: 8 },
                    scale: 2.1,
                },
                {
                    ...burstStarGeneral,
                    delaySeconds: 0.03,
                    location: { edge: "right", zone: 6 },
                    scale: 1.2,
                },
                {
                    ...burstStarGeneral,
                    delaySeconds: 0.02,
                    location: { edge: "bottom", zone: 7 },
                    scale: 1,
                },
                {
                    ...burstStarGeneral,
                    delaySeconds: 0.01,
                    location: { edge: "bottom", zone: 4 },
                    scale: 0.8,
                },
                {
                    ...burstStarGeneral,
                    delaySeconds: 0.1,
                    location: { edge: "bottom", zone: 0 },
                    scale: 2.8,
                },
                {
                    ...burstStarGeneral,
                    delaySeconds: 0.03,
                    location: { edge: "left", zone: 1 },
                    scale: 1.4,
                },
                {
                    ...burstStarGeneral,
                    delaySeconds: 0.03,
                    location: { edge: "left", zone: 5 },
                    scale: 1.9,
                },
            ],
        },
        {
            type: "greetingLinesAsScenes",
            variant: "intro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
            showLogo: true,
            sceneBackground: greetingLinesAsScenesSceneBackground,
        },
        {
            type: "clip-series-basic",
            showLogo: true,
        },
        {
            type: "greetingLinesAsScenes",
            variant: "outro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
            sceneBackground: greetingLinesAsScenesSceneBackground,
        },
        {
            type: "outro",
            colorVariant: "darkBlue",
        },
    ],
    styles: {
        textBox: {
            backgroundColor: "#fff",
            backgroundOpacity: 0,
            backgroundBlur: 2,
            textAlign: "center",
            textColor: "#bc4b4d",
            fontFamily: "Londrina Solid",
            fontWeight: "bold",
            fontSize: 140,
            leading: 1.2,
            tracking: 0,
        },
        clips: {
            textVariant: {
                variant: "slide-in-static",
                entranceVariant: "slide-to-flush-left",
                startOffsetSeconds: 0.6,
                cards: [
                    {
                        backgroundColor: "#1e1e24",
                        backgroundOpacity: 1,
                        borderRadius: "1.5rem",
                    },
                ],
            },
            betweenTransition: sceneTransition,
            title: {
                backgroundColor: "#fff",
                backgroundOpacity: 1,
                textColor: "#bc4b4d",
                fontFamily: "Londrina Solid",
                fontWeight: "normal",
                fontSize: 70,
                nudge: 2,
                textTransform: "none",
            },
            subtitle: {
                backgroundColor: "#fff",
                backgroundOpacity: 1,
                textColor: "#bc4b4d",
                fontFamily: "Londrina Solid",
                fontWeight: "normal",
                fontSize: 40,
                nudge: 2,
                textTransform: "uppercase",
            },
            scaleFactor: 1,
        },
        watermark: {
            opacity: 0.8,
            margin: 32,
            enterTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
            exitTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
        },
        sceneTransition,
    },
    colorPalettes: ["BigCongrats"],
};
